import React, { Suspense, lazy } from 'react'
import Home from './component/Home'
import Navbar from './component/NavBar'
import Footer from './component/Footer'
import { Routes, Route, Navigate } from "react-router-dom"
import ScrollToTop from './ScrollToTop'

const Contact = lazy(() => import('./component/Contact'))
const Work = lazy(() => import('./component/Work'))
const InteriorPage = lazy(() => import('./component/work/InteriorPage'))
const ArchiPage = lazy(() => import('./component/work/ArchiPage'))
const VFXPage = lazy(() => import('./component/work/VFXPage'))
const UEPage = lazy(() => import('./component/work/UEPage'))
const ProductPage = lazy(() => import('./component/work/ProductPage'))
const FDMPage = lazy(() => import('./component/work/FDMPage'))
const ConceptPage = lazy(() => import('./component/work/ConceptPage'))

export default function App() {
  return (
    <div>
      <Navbar />
      <ScrollToTop />
      <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/interior" element={<InteriorPage />} />
          <Route path="/arch" element={<ArchiPage />} />
          <Route path="/vfx" element={<VFXPage />} />
          <Route path="/ue" element={<UEPage />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/3d" element={<FDMPage />} />
          <Route path="/concept" element={<ConceptPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>
      <Footer />
    </div>
  )
}
